import React from 'react';
import {EditButton, List, useListContext} from 'react-admin';
import {Button, Card, CardActions, CardContent, CardMedia, Grid, Typography,} from '@mui/material';
import {Link} from 'react-router-dom';
import {makeStyles} from '@mui/styles';
import querystring from 'query-string';

const useStyles = makeStyles({
    root: {
        marginTop: '1em',
    },
    media: {
        height: 140,
    },
    title: {
        paddingBottom: '0.5em',
    },
    actionSpacer: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    icon: {paddingRight: '0.5em'},
    link: {
        display: 'inline-flex',
        alignItems: 'center',
    },
});

const LinkToRelatedCampaigns = ({record}) => {
    const classes = useStyles();

    return <Button
        size="small"
        color="primary"
        component={Link}
        to={{
            pathname: '/campaign',
            search: querystring.stringify({
                filter: JSON.stringify({id: record.challenge_campaigns.campaign.id}),
            }),
        }}
        className={classes.link}
    >
        Campagnes
    </Button>
}

const ChallengeGrid = (props) => {
    const classes = useStyles(props);
    const {data} = useListContext();
    return data ? (
        <Grid container spacing={2} className={classes.root}>
            {data.map(record => (
                <Grid key={record.id} xs={12} sm={6} md={4} lg={3} xl={2} item>
                    <Card>
                        <CardMedia
                            image={record.abstract_image}
                            className={classes.media}
                        />
                        <CardContent className={classes.title}>
                            <Typography
                                variant="h5"
                                component="h2"
                                align="center"
                            >
                                {record.abstract_title}
                            </Typography>
                        </CardContent>
                        <CardActions
                            classes={{spacing: classes.actionSpacer}}
                        >
                            {/* <LinkToRelatedCampaigns record={record}/> */}
                            <EditButton
                                basePath="/challenge"
                                record={record}
                                label="modifier"
                            />
                        </CardActions>
                    </Card>
                </Grid>
            ))}
        </Grid>
    ) : null;
}

const ChallengeList = (props) => {
    return <List
        {...props}
        component="div"

    >
        <ChallengeGrid/>
    </List>;
};

export default ChallengeList;
